// extracted by mini-css-extract-plugin
module.exports = {"container":"container--UC3pf","game-container":"game-container--RusV0","close":"close--0qWHH","game-wrap":"game-wrap--q1mdT","mic":"mic--oRPpV","icon":"icon--mYM-P"};